import { StringVariant } from 'src/features/string-group-detail/types';

/**
 * The group's CX IDs that have no variant yet, in the group's own order.
 *
 * Both sources of "already has one" count: the server's variant list AND the
 * pending variants from the local draft (`computePendingVariants`). The pending
 * source is load-bearing — without it a user could create two variants for the
 * same CX ID in one session and `upsertVariant` would silently overwrite the
 * first.
 *
 * Callers pass the pending list so the "which CX IDs are pending" decision is
 * made once, in `computePendingVariants`, and shared with the variants table.
 * Passing the raw draft list instead is harmless — pending is a subset of it and
 * the union with the server list is the same — but then the two derivations are
 * no longer literally the same value.
 */
export function computeAvailableCxIds(
  cxIds: readonly string[],
  serverVariants: readonly { cxId: string }[] | null | undefined,
  pendingVariants: readonly StringVariant[] | null | undefined,
): string[] {
  const taken = new Set<string>([
    ...(serverVariants ?? []).map((v) => v.cxId),
    ...(pendingVariants ?? []).map((v) => v.cxId),
  ]);
  return cxIds.filter((cxId) => !taken.has(cxId));
}
